export const defaultAvatarRegex = new RegExp('assets/users/images|missing')

export const isDefaultAvatar = image => defaultAvatarRegex.test(image)

export const getAvatar = (image, defaultAvatar) =>
  (!image || isDefaultAvatar(image)) ? defaultAvatar : image
